// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__3y1M2","title":"style_title__3xEgY","time":"style_time__TFnUe","content":"style_content__207OI","tabs":"style_tabs__2CgG1"};